import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { generatePath } from 'react-router';
import { useNavigate } from 'react-router-dom';

import { CardActionArea } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

import buildingsApi from 'Api/buildings';

import { ROUTE_TESTS } from 'Config/routes';

import { setCurrentBuildingName } from 'Features/Results/resultsSlice';

import { getErrorMessageFromResponse, isValidResponse } from 'Utils';

export default function ResultsItem({ item, index }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [previewImageName, setPreviewImageName] = React.useState(null);
  const [previewImageURL, setPreviewImageURL] = React.useState(null);

  useEffect(() => {
    try {
      const imgName = item.buildingmetadata.previewImages[0].filename;
      if (imgName) {
        setPreviewImageName(imgName);
        getPreviewImageUrl();
      }
    } catch (err) {}
  }, [item]);

  const getPreviewImageUrl = async () => {
    try {
      const response = await buildingsApi.getDisplayImagePresignedUrl(
        item.buildingid,
      );
      if (isValidResponse(response)) {
        const presignedURL = response.data.data;
        setPreviewImageURL(presignedURL);
      } else throw new Error(getErrorMessageFromResponse(response));
    } catch (err) {
      console.log(err);
    }
  };

  /**
   * Open results of project
   * @param buildingId
   */
  const handleClick = (event, buildingId) => {
    dispatch(setCurrentBuildingName(item.buildingname));

    const _path = generatePath(ROUTE_TESTS, { buildingId: buildingId });
    /** This is for opening it in new tab through command + click or ctrl + click */
    if (event.metaKey || event.ctrlKey) {
      window.open(_path);
      return;
    }
    navigate(_path);
  };

  const BlankImageUrl = useMemo(() => {
    const width = 400;
    const height = 100;

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    // Get the canvas context and draw a white rectangle
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, width, height);

    // Get the data URL of the image
    const imageUrl = canvas.toDataURL('image/png');

    return imageUrl;
  }, []);

  return (
    <>
      <Card key={item.buildingid}>
        <CardActionArea
          onClick={(e) => handleClick(e, item.buildingid)}
          sx={{
            width: 400,
            height: 370,
            display: 'flex',
            flexWrap: 'wrap',
            alignContent: 'space-between',
          }}
        >
          <CardMedia
            component="img"
            width="400"
            image={
              previewImageName && !previewImageURL
                ? BlankImageUrl
                : previewImageURL
                ? previewImageURL
                : `/building_${index % 5}.jpg`
            }
            alt="building-image"
          />
          <CardContent sx={{ width: '100%' }}>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{ textAlign: 'left' }}
            >
              {item.buildingname}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ textAlign: 'left' }}
            >
              {item?.sitename} {item?.siteaddress}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  );
}
